import React, { FunctionComponent } from "react";
import { Outlet } from "react-router-dom";

interface TaskSearchPageProps {}

/**
 * TaskSearchPage is the outlet shell for the /task-search route tree.
 * It renders the list or, when a row is opened, the sub-task details.
 *
 * @component
 * @returns {JSX.Element} The matched child route.
 */
const TaskSearchPage: FunctionComponent<TaskSearchPageProps> = (
  props: TaskSearchPageProps
) => {
  return <Outlet />;
};

export default TaskSearchPage;
